export default __webpack_public_path__ + "static/media/TOYOTA02.2a0cff21.png";